import type {
	ColDef,
	ColGroupDef,
	ICellRendererParams,
} from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { ProductChange } from "../models/ProductChange";

interface UseTableDataProps {
	onDelete: (change: ProductChange) => void;
}

const groupSeparator = "ag-column-group-separator";

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: (ColDef<ProductChange> | ColGroupDef<ProductChange>)[] = [
		{
			headerName: "Product",
			marryChildren: true,
			headerClass: groupSeparator,
			children: [
				{
					field: "InitialProductSizeName",
					headerName: "From",
					flex: 1,
					sortable: true,
					filter: true,
					valueFormatter: (params: { value: string | null }) =>
						params.value ?? "ALL",
				},
				{
					field: "FinalProductSizeName",
					headerName: "To",
					flex: 1,
					sortable: true,
					filter: true,
					valueFormatter: (params: { value: string | null }) =>
						params.value ?? "ALL",
					headerClass: groupSeparator,
				},
			],
		},
		{
			headerName: "Goal",
			marryChildren: true,
			headerClass: groupSeparator,
			children: [
				{
					field: "GoalTime",
					headerName: "Time",
					flex: 1,
					valueFormatter: (params: { value: number | null }) =>
						params.value != null ? params.value.toFixed(2) : "",
					headerClass: groupSeparator,
				},
			],
		},
		{
			headerName: "History",
			marryChildren: true,
			children: [
				{
					field: "HistoryQuantity",
					headerName: "Quantity",
					flex: 1,
				},
				{
					field: "HistoryTime",
					headerName: "Time",
					flex: 1,
					valueFormatter: (params: { value: number | null }) =>
						params.value != null ? params.value.toFixed(2) : "",
				},
			],
		},
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			suppressSpanHeaderHeight: true,
			cellRenderer: (params: ICellRendererParams<ProductChange>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as ProductChange);
								}}
								color="error"
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
